import { api } from "@/lib/api";

const KEY = "cetele_offline_queue";

export const readQueue = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const write = (q) => localStorage.setItem(KEY, JSON.stringify(q));

export const enqueueMark = (item) => {
  const q = readQueue().filter((x) => x.voter_id !== item.voter_id);
  q.push(item);
  write(q);
  return q.length;
};

export const dropMark = (voterId) => {
  write(readQueue().filter((x) => x.voter_id !== voterId));
};

/** Kuyruğu sırayla gönderir; başarısızsa kuyrukta bırakır. Döner: {sent, failed, left}. */
export const flushQueue = async () => {
  const q = readQueue();
  if (!q.length) return { sent: 0, failed: 0, left: 0 };
  let sent = 0, failed = 0;
  const remaining = [];
  for (const item of q) {
    try {
      if (item.choice) {
        await api.post("/election-day/tally", { voter_id: item.voter_id, choice: item.choice });
        sent += 1;
        continue;
      }
      const { data } = await api.post("/election-day/mark", { voter_id: item.voter_id });
      // Kuyruktaki hedef durum sunucudaki durumla uyuşmazsa bir kez daha çevir.
      if (typeof item.target === "boolean" && data.marked !== item.target) {
        await api.post("/election-day/mark", { voter_id: item.voter_id });
      }
      sent += 1;
    } catch (e) {
      if (e.response && e.response.status >= 400 && e.response.status < 500) {
        failed += 1; // kalıcı hata (ASKI, yetki) — kuyruktan düş
      } else {
        remaining.push(item);
      }
    }
  }
  write(remaining);
  return { sent, failed, left: remaining.length };
};
